  <!-- main app container -->
  <div class="card m-3"> 
    <div class="card-body">

      
   <img src="./assets/Construction-Machine-PNG-Clipart-Background.png"  *ngIf="isMobile" width="40%" style="float: right; vertical-align: top;">
   
   <img src="./assets/Construction-Machine-PNG-Clipart-Background.png"  *ngIf="!isMobile" width="20%" style="float: right; vertical-align: top;">
    
   
   
   <h2>Equipment</h2><br><br>
      <a routerLink="/equipment/add">
        <button mat-button color="success"><mat-icon>add</mat-icon>ADD</button></a>
      <div class="mat-elevation-z8">
       
        <br>
        <br>

        <table class="table table-striped table-sm">
    <thead>
      <tr>
        <th></th>
        <th>Name</th>
        <th *ngIf="!isMobile">Description</th>
        <th *ngIf="!isMobile">Quantity</th>
        <th *ngIf="!isMobile">Manufacturer</th>
        <th>Daily Rate</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let equip of equipment">
        <td>
          <img *ngIf="equip.imageUrl" [src]="equip.imageUrl" alt="{{ equip.name }}" class="equip-thumb">
          <mat-icon *ngIf="!equip.imageUrl" class="equip-thumb-placeholder">construction</mat-icon>
        </td>
        <td>{{ equip.name }}</td>
        <td *ngIf="!isMobile">{{ equip.description }}</td>
        <td *ngIf="!isMobile">{{ equip.quantity }}</td>
        <td *ngIf="!isMobile">{{ equip.manufacturer?.name }}</td>
        <td>{{ equip.dailyRate ? ('$' + equip.dailyRate + '/day') : '—' }}</td>
        <td>
          <button (click)="editEquipment(equip)">Edit</button>
        </td>
      </tr>
    </tbody>
  </table>
  </div>
  </div>